import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function FullLayout({ children }) {
  return <Route render={() => <>{children}</>} />;
}
